import React, {useContext} from "react";
import "./styles/OpenWindow.css";
import back from "./assets/back.png";
import close from "./assets/close.png";
import FileManager from "./FileManager";
import Resume from "./Resume";
import Skill from "./Skill";
import { desktopContext } from "./context/desktopContext";
import ProjectView from "./ProjectView";
import AboutMe from "./AboutMe";
import CodingJudge from "./workexp/CodingJudge";

const OpenWindow = () => {


  const cntxt = useContext(desktopContext)
  
  const apps = ["Resume", "Filemanager", "Skills", "About Me", "Work Experience"]

  var element = <></>

  if (cntxt.app === 'Resume'){
    element = <Resume/>
  }else if (cntxt.app === 'Filemanager'){
    element = <FileManager/>
  }else if (cntxt.app === 'Skills'){
    element = <Skill/>
  }else if(cntxt.app === 'About Me'){
    element = <AboutMe/>
  }else if(cntxt.app === "Work Experience"){
    element = <CodingJudge/>
  }else{
    element = <ProjectView/>
  }

  const backOnCLickHandler = () => {
    if (apps.includes(cntxt.app)){
      cntxt.setWindowOpen(false)
    }
    else{
      cntxt.setOpenWindowTitle('Projects')
      cntxt.setApp('Filemanager')
    }
  }

  return (
    <>
      <div className="centered-div">
        <div className="title-bar">
          <img
            className="title-bar-icon-back"
            src={back}
            alt="Good Game Easy"
            onClick={backOnCLickHandler}
          />
          <p className="title-bar-text">{cntxt.openWindowTitle}</p>
          <img
            className="title-bar-icon-close"
            src={close}
            alt="Good Game Easy"
            onClick={() => cntxt.setWindowOpen(false)}
          />
        </div>
        {element}
      </div>
    </>
  );
};

export default OpenWindow;
